// This file was generated using `pay js:run gql-v1 --type=fragment --name=LegalEntityPersonVerificationArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {legalEntityPersonVerificationDocumentArkFragment} from './legalEntityPersonVerificationDocumentArkFragment';

import type {LegalEntityPersonVerificationDocumentArkFragmentData} from './legalEntityPersonVerificationDocumentArkFragment';

const doc = gql`
  fragment LegalEntityPersonVerificationArkFragment on OpenapiLegalEntityPersonVerification {
    additional_document {
      ...LegalEntityPersonVerificationDocumentArkFragment
    }
    details
    details_code
    document {
      ...LegalEntityPersonVerificationDocumentArkFragment
    }
    status
  }

  ${legalEntityPersonVerificationDocumentArkFragment}
`;

export const legalEntityPersonVerificationArkFragment: LegalEntityPersonVerificationArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type LegalEntityPersonVerificationArkFragmentData = {
  readonly __typename: 'OpenapiLegalEntityPersonVerification';
  readonly details: string | null;
  readonly details_code: string | null;
  readonly status: string;
  readonly additional_document: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityPersonVerificationDocument'},
    [LegalEntityPersonVerificationDocumentArkFragmentData]
  > | null;
  readonly document: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityPersonVerificationDocument'},
    [LegalEntityPersonVerificationDocumentArkFragmentData]
  > | null;
};

export type LegalEntityPersonVerificationArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const legalEntityPersonVerificationArkFragmentPermissions = {
  ...legalEntityPersonVerificationDocumentArkFragment.permissions,
} as const;

doc.permissions = legalEntityPersonVerificationArkFragmentPermissions;

export type LegalEntityPersonVerificationArkFragmentPermissions =
  V1PermissionToken<typeof legalEntityPersonVerificationArkFragmentPermissions>;

export type LegalEntityPersonVerificationArkFragmentDocument = GraphQlDocument<
  LegalEntityPersonVerificationArkFragmentData,
  LegalEntityPersonVerificationArkFragmentVariables,
  LegalEntityPersonVerificationArkFragmentPermissions
>;
